import { render, staticRenderFns } from "./Emails.vue?vue&type=template&id=32fe6e2b&scoped=true"
import script from "./Emails.vue?vue&type=script&lang=ts"
export * from "./Emails.vue?vue&type=script&lang=ts"
import style0 from "./Emails.vue?vue&type=style&index=0&id=32fe6e2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fe6e2b",
  null
  
)

export default component.exports